import React, { useState } from "react";
import { motion } from "framer-motion";
import cedarImage from "../assets/cedar.webp";
import areaImage from "../assets/Area.webp";
import cupImage from "../assets/cup.webp";
import feiruz from "../assets/feiruz.webp";
import cupSymbol from "../assets/cup-symbol.webp";
import belowTemple from "../assets/SVG/belowTemples.svg";
import TemplesOnly from "./TemplesOnly";

const HeroSection = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <section id="home" className="min-h-screen ios-h-screen pb-0 snap-start flex flex-col lg:flex-row items-center justify-start pt-20 sm:pt-0 sm:justify-center text-center md:text-left px-4 py-4 sm:py-12 gap-4 lg:gap-10 relative bg-heritage-pattern 2xl:container 2xl:mx-auto">
      <div className="fixed bottom-5 left-5 z-40">
        <button
          type="button"
          aria-label="Open navigation menu"
          aria-expanded={menuOpen}
          aria-controls="site-navigation"
          onClick={() => setMenuOpen((isOpen) => !isOpen)}
          className="flex h-12 w-12 items-center justify-center rounded-full border border-[#d4c2ae] bg-white/90 text-xl text-[#7c5e3c] shadow-md backdrop-blur-sm transition hover:bg-white"
        >
          <span className="leading-none">☰</span>
        </button>
        {menuOpen && (
          <nav id="site-navigation" aria-label="Primary navigation" className="absolute bottom-full left-0 mb-2 w-44 rounded-2xl border border-[#d4c2ae] bg-white/95 p-2 shadow-lg backdrop-blur-sm">
            {[
              ["About", "#about"],
              ["Education", "#education"],
              ["Experience", "#experience"],
              ["Skills", "#skills"],
              ["Projects", "#projects"],
              ["Contact", "#contact"],
            ].map(([label, href]) => (
              <a key={href} href={href} onClick={(event) => {
                event.preventDefault();
                setMenuOpen(false);
                document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });
                window.history.replaceState(null, "", href);
              }} className="block rounded-xl px-3 py-2 text-sm text-[#4e5d4e] transition hover:bg-[#f1ece6] hover:text-[#7c5e3c]">
                {label}
              </a>
            ))}
          </nav>
        )}
      </div>
      {/* Bottom Right Baalbek + Gradient Glow */}
     {/* Bottom Right Baalbek + Gradient Glow */}
<div className="absolute bottom-0 right-0 md:right-3 z-0 w-80 pointer-events-none">
  <img src={belowTemple} onLoad={() => setImageLoaded(true)} alt="temple" className="w-80" />
  <TemplesOnly shouldAnimate={imageLoaded} className="w-24 absolute right-[7.5%] bottom-[73%]" />
</div>


      {/* Top Right Images */}
      <div className="hidden md:flex fixed top-4 right-4 z-10 flex-col items-end gap-3">
        <img
          src={cedarImage}
          alt="Green Cedar"
          className="w-12 sm:w-20 lg:w-24 rounded-lg"
        />
        <img
          src={areaImage}
          alt="Area"
          className="w-12 sm:w-20 lg:w-24 rounded-lg shadow-lg"
        />
      </div>

      {/* Top Left Feiruz */}
      <div className="hidden md:block fixed top-4 left-4 z-10">
        <img
          src={feiruz}
          alt="Feiruz"
          className="w-20 sm:w-40 lg:w-48 max-w-[12rem] sm:max-w-[16rem] md:max-w-[20rem] h-auto rounded-lg"
        />
      </div>

      {/* Left: Profile + Cup Symbol */}
      <div className="w-full md:w-1/3 flex justify-center lg:justify-end relative">
        <div className="relative">
          <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-52 lg:h-52 overflow-hidden rounded-full border-4 border-[#b88c5a] shadow-lg bg-white">
            <img
              src="/jad-profile.jpg"
              alt="Jad Mcheik"
              className="h-full w-full -translate-x-2 scale-110 object-cover sm:-translate-x-3"
            />
          </div>
          <img
            src={cupSymbol}
            alt="Cup Symbol"
            className="absolute rotate-[-40deg] -top-6 -right-6 sm:-top-7 sm:-right-7 md:-top-8 md:-right-12 lg:-top-16 lg:-right-14  w-12 h-16 sm:16 sm:h-20 md:w-20 md:h-24 lg:w-28 lg:h-32 object-contain"
          />
        </div>
      </div>

      {/* Text + Cup Stack */}
      <div className=" flex flex-col lg:flex-row items-center lg:items-start justify-start w-full lg:w-2/3">
        {/* Text Block */}
        <div className="text-center lg:text-left max-w-lg xl:max-w-2xl flex-1">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-heritage-bold mb-4 tracking-wide text-[#7c5e3c] drop-shadow-lg flex flex-wrap justify-center lg:justify-start">Jad Mcheik</h1>
          <p className="text-base sm:text-lg lg:text-xl text-[#4e5d4e] mb-4 max-w-prose mx-auto sm:mx-0">
            Software developer building thoughtful web, mobile, and data-driven
            experiences.
          </p>
          <span className="block text-[#b88c5a] italic text-sm sm:text-base lg:text-lg mb-2 font-heritage-bold">
          “Roots deep in heritage, eyes set on the future.”
          </span>
        </div>

        {/* Cup Stack (always to the right of text) */}
        <div className="hidden lg:flex flex-col gap-2 sm:gap-3 rotate-[-30deg] ">
          <motion.img
            src={cupImage}
            alt="Cup Top"
            className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 xl:w-14 xl:h-14 object-contain"
            animate={{ rotate: [20, 28, 20] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.img
            src={cupImage}
            alt="Cup Middle"
            className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 xl:w-14 xl:h-14 object-contain"
            animate={{ rotate: [-10, -18, -10] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.img
            src={cupImage}
            alt="Cup Bottom"
            className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 xl:w-14 xl:h-14 object-contain"
            animate={{ rotate: [0, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
